<template>
    <main>
        <div class="row">
            <div class="col-md-6">
                <div class="titles">
                    <h2 class="uppercase"><b><i class="fa fa-university"></i> Escolas</b></h2>
                </div>
            </div>
            <div class="col-sm-6" v-if="!hasDisabled">
                <button class="btn btn-success uppercase pull-right" @click="openCreate()">
                    Criar
                </button>
            </div>
            
            <div class="col-sm-12">

                <div class="table-responsive standard-table header-cinza">
                    <table>
                        <thead>
                            <tr>
                                <th>Escola</th>
                                <th>Situação</th>
                                <!-- Task-2612 -->
                                <th v-if="escolaLogada==276">Operador</th>
                                <th class="text-center" width="200"><i class="fa fa-cog"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                <td>{{ item.escola.nomeEscola }}</td>
                                <td>{{ item.auxSituacao.nmSituacao }}</td>
                                <td v-if="escolaLogada==276">
                                    <label class="custom-control custom-checkbox">                                      
                                        <input type="checkbox" id="item.escola.nomeEscola" class="custom-control-input" v-model="item.ehOperador" @click="executeEhOperador(item);">
                                        <span class="custom-control-indicator"></span>
                                        <span class="custom-control-description"></span>
                                    </label>
                                </td>

                                <td class="text-center">
                                    <button type="button" class="btn btn-sm btn-success" v-b-tooltip title="Cargos" @click="openCargo(item)">
                                        <i class="fa fa-briefcase"></i>
                                    </button>
                                    <button v-if="!hasDisabled" type="button" class="btn btn-sm btn-warning" v-b-tooltip title="Tags" @click="openTag(item)">
                                        <i class="fa fa-tags"></i>
                                    </button>
                                    <button v-if="!hasDisabled" type="button" class="btn btn-sm btn-primary" v-b-tooltip title="Editar" @click="openEdit(item)">
                                        <i class="fa fa-pencil"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered size="lg" v-model="dialogCargo" :hide-footer="true" :title="hasDisabled ? 'Detalhes do cargo': 'Configurar Cargos'">
            <colaborador-escola-cargo v-if="dialogCargo" :is-modal="true" :mostrar-campos="true" :has-disabled="false" :colaborador-id="colaboradorId" :escola-id="escolaId" @on-saved="onSaved()" @on-back="executeFilter()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered size="lg" v-model="dialogTag" :hide-footer="true" title="Configurar tags">
            <colaborador-tag v-if="dialogTag" :mostrar-campos="true" :colaborador-id="colaboradorId" :escola-id="escolaId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogCreate" :hide-footer="true" title="Criar">
            <form-create v-if="dialogCreate" :colaboradorId="colaboradorId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogEdit" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :colaborador-id="colaboradorId" :escola-id="escolaId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'
    import Auth from '@/common/auth'

    import formCreate from './form-create'
    import formEdit from './form-edit'
    import colaboradorTag from './colaboradortag'
    import colaboradorEscolaCargo from './colaboradorescolacargo'

    export default {
        name: 'colaboradorescola',
        mixins: [base],
        props: { colaboradorId: Number, hasDisabled : Boolean },
        components: {
            formCreate,
            formEdit,
            colaboradorTag,
            colaboradorEscolaCargo
        },
        data() {
            return {
                title: '',
                resources: {
                    filter: 'colaboradorescola',
                    remove: 'colaboradorescola',
                    updateOperador: 'colaboradorescola/salvaroperador',
                },
                                
                escolaLogada:null,

                dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,
                dialogTag: false,
                dialogCargo: false,

                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openCargo: function (model) {
                this.colaboradorId = model.colaboradorId;
                this.escolaId = model.escolaId;
                this.dialogCargo = true;               
            },
            openTag: function (model) {
                this.colaboradorId = model.colaboradorId;
                this.escolaId = model.escolaId;
                this.dialogTag = true;
            },
            openEdit: function (model) {
                this.colaboradorId = model.colaboradorId;
                this.escolaId = model.escolaId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
                this.dialogTag = false;
                this.dialogCargo = false;
            },

            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.executeLoad();
                    this.hideAll();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                //console.log('entrei2')
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                this.filter.colaboradorId = this.colaboradorId;
               // console.log("endereco", this.resources);
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    //console.log("lista de escolas", this.result.items);
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },
            //Task-2612
            executeEhOperador: function (obj) {
                obj.ehOperador = obj.ehOperador ? false : true;

                //console.log('colaborador' + obj.colaboradorId + " escola id" + obj.escolaId + "operador " + obj.ehOperador);
                if (obj) this.model = {
                    colaboradorId: obj.colaboradorId,
                    escolaId: obj.escolaId,
                    ehOperador: obj.ehOperador
                };
                
                new Api(this.resources.updateOperador).put(this.model).then(() => {
                    this.defaultSuccessResult("Item alterado com sucesso");
                    this.executeLoad();
                    this.hideAll();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },
            

        },

        mounted() {
            this.executeFilter();                        
            //let escolaIdLogada = Auth.currentUser().tenant;
            this.escolaLogada = Auth.currentUser().tenant;
            //console.log("escola logada", this.escolaLogada);
        }

    };
</script>